import type { UserMenuType } from './types'
import { computed } from 'vue'
import { useAuth } from '@/entities/Auth'

export const useModel = () => {
  const { isPermissions } = useAuth()

  const menuItemList: UserMenuType[] = [
    { name: 'itf.profile', link: '/users/profile', permissions: [] },
  ]

  const menuList = computed(() => {
    return menuItemList.filter((menuItem) => isPermissions(menuItem.permissions))
  })

  return {
    menuList,
  }
}
